import styled from 'styled-components';
export const PageWrapper = styled.div `
  padding: 24px;
  max-width: 1400px;
  margin: 0 auto;
  background-color: #f5f5f5;
  min-height: 100vh;
`;
export const Title = styled.h1 `
  font-size: 28px;
  font-weight: 600;
  margin: 0;
  color: #000;
`;
export const Description = styled.p `
  font-size: 14px;
  color: #666;
  margin: 0;
`;
